<template>
  <div class="ActTwelveBar" ref="ActTwelveBar" v-if="isShow">

    <CgModalMiddle
      v-show="isShow"
      :is-show-close="false">
      <div class="ActTwelveBarContent"
           @click.stop="toAct" slot="modal_content"
      >
          <div class="close-box"
               @click.stop="closeBar"
          >
            <i class="iconfont icon-cha"></i>
          </div>
      </div>
    </CgModalMiddle>


  </div>
</template>

<script>
import {MODEL_ACT_TWELVE_BAR} from "@/constant/MODELS";
import {fnLocalStorage} from "@/fn";
import {ACT, NEW_YEAR_ACT, PAY_COMPANY_NEW} from "@/constant/_Public/Path";
import {fnBasic} from "~/fn/_fn";

export default {
  name: "ActTwelveBar",
  data() {
    return {
      MODEL_ACT_TWELVE_BAR,
      ACT,
      isShow: false,
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.initShow();
    },

    initShow() {
      console.log('-----MODEL_ACT_TWELVE_BAR-----------')
      console.log(fnLocalStorage.getItemDate(MODEL_ACT_TWELVE_BAR))
      let flag = fnLocalStorage.getItemDate(MODEL_ACT_TWELVE_BAR);
      this.isShow = flag == undefined;
    },

    toAct(){
      this.closeBar();
      fnBasic.navigationTo(NEW_YEAR_ACT)
    },

    closeBar() {
      this.isShow = false;
      fnLocalStorage.setItemDate(MODEL_ACT_TWELVE_BAR, 1);

      if (this.$refs.ActTwelveBar){
        this.$refs.ActTwelveBar.style = `display:none`;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ActTwelveBar {


  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.25) !important;
    z-index: 898;
  }

  .ActTwelveBarContent {
    @include BgImage2(620px,779px, 'act/act-bar22.png', 1);
    background-size: 620px 779px;
  }

  .close-box {
    width: 38px;
    height: 38px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 80px;
    z-index: 900;
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 1);
    }

    .icon-cha {
      font-size: 17px;
      color: rgba(154, 45, 31, 1);
    }

  }
  .inner_center {
    height: 100%;
    position: relative;





  }
}
</style>
